module.exports = __webpack_public_path__ + "static/media/img14.41ed6943.jpeg";